module.exports = __webpack_public_path__ + "static/media/popcorn-score.7d5f3cd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svod/popcorn-score.png
// module id = 625
// module chunks = 0